import React, { ComponentPropsWithRef, forwardRef } from 'react';
import { Checkmark, Container, Content } from './Checkbox.styles';
import { MarginProps } from '../../../theme/styledProps';
import { Text } from '../Text/Text';
import { Box } from '../Box/Box';
import { HelperText } from '../HelperText/HelperText';
import { extractMarginProps } from '../utils/extractMarginProps';

interface CheckboxBaseProps extends ComponentPropsWithRef<'input'> {
  hideFocus?: boolean;
}

export const CheckboxBase = forwardRef<HTMLInputElement, CheckboxBaseProps>(
  ({ children, hideFocus, className, ...rest }, ref) => {
    return (
      <Container as={children ? 'label' : 'div'} hideFocus={hideFocus} className={className}>
        <input ref={ref} type="checkbox" {...rest} />

        <Content>
          <Checkmark css={{ marginTop: children ? 2 : 0 }} />
          <Box>{children}</Box>
        </Content>
      </Container>
    );
  },
);

export interface CheckboxProps extends ComponentPropsWithRef<'input'>, MarginProps {
  isOverflowWrap?: boolean;
  helperText?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ isOverflowWrap, children, helperText, ...rest }, ref) => {
    return (
      <Box display="flex" py="4" px={6} {...extractMarginProps(rest)}>
        <CheckboxBase ref={ref} css="flex: 1" {...rest}>
          {(children || helperText) && (
            <>
              {children && (
                <Text fontWeight={500} pl="8" isOverflowWrap={isOverflowWrap}>
                  {children}
                </Text>
              )}
              {helperText && <HelperText ml="8">{helperText}</HelperText>}
            </>
          )}
        </CheckboxBase>
      </Box>
    );
  },
);
